<template>
    <div class="vue-tempalte">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <form ref="serviceForm" @submit.prevent="onFormSubmit">
                        <h3>Добави брояч</h3>
                        <div class="form-group">
                            <label>Заглавие</label>
                            <input type="text" class="form-control form-control-lg" v-model="counters.name" required>
                        </div>

                        <div class="form-group">
                            <label>Описание</label>
                            <div class="editor-wrapper">
                                <vue-editor v-model="counters.description"  required></vue-editor>
                            </div>
                        </div>

                        <div class="form-group">
                            <button :disabled="!counters.description" class="btn btn-primary btn-block">Запази</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                counters: {
                    name: '',
                    description: '',
                    createdAt: Date.now()
                }
            }
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault();
                db.collection('counters').add(this.counters).then(() => {
                    alert("Успешно добавен брояч!");
                    this.counters.name = null;
                    this.counters.description = null;
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>
